export const REASONS_REQUIRING_ORDER_NUMBER = [
  "Where is my order",
  "Cancel order",
  "RMA request",
  "Delivery time exceeded",
  "Complaint",
  "Payment support",
  "Request an order receipt"
];

export const REASONS_REQUIRING_FILE_UPLOAD = [
  "Broken product",
  "Wrong product",
  "Wrong information on the website",
  "Incomplete product"
];



// WEBPACK FOOTER //
// ./src/config/support_reasons.tsx